import { WhatsappIcon } from "@keepoinc/site-page-react-component";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import Input from "../../../../components/Form/Input/input";
import PhoneNumberInput, {
  isPossibleWhatsappNumber,
  sanitizePhoneDigits,
} from "../../../../components/Form/PhoneNumberInput";
import { Form, FormGroup } from "../../../../components/Form/styles";
import { Box } from "../../../../components/Layout";
import SaveBar from "../../../../components/SaveBar";
import { SubHeader } from "../../../../components/SubHeader";
import { FloatingWhatsappSection } from "../../../../model/site";
import { useSection } from "../../hooks/Section";
import { Container } from "./styles";

const FloatingWhatsappPage = () => {
  const { t } = useTranslation();

  const setDefaultValues = useCallback((newly: boolean, section: FloatingWhatsappSection) => {
    if (newly) {
      section.whatsapp = "+55";
    }
    return section;
  }, []);

  const { section, setSection, saveSection, hasUnsavedChanges } = useSection<FloatingWhatsappSection>(
    "floating-whatsapp",
    setDefaultValues
  );

  const saveHandler = () => {
    saveSection({
      ...section,
      whatsapp: sanitizePhoneDigits(section.whatsapp),
    });
  };

  const hasValidWhatsapp = isPossibleWhatsappNumber(section.whatsapp);

  return (
    <Container>
      <SubHeader
        title={t("pages.editor.floatingWhatsapp.header.title")}
        crumbs={[{ label: t("pages.editor.preview.footer.actions.sections"), to: "/editor/sections" }]}
        hasUnsavedChanges={hasUnsavedChanges}
      />
      <Form>
        <Box>
          <FormGroup>
            <PhoneNumberInput
              id="floatingWhatsapp"
              value={section.whatsapp}
              label={t("pages.editor.floatingWhatsapp.form.whatsapp")}
              required
              onChange={whatsapp => setSection({ ...section, whatsapp })}
              icon={
                hasValidWhatsapp ? (
                  <WhatsappIcon width={24} height={24} color="white" background="var(--color-neutral-darkness)" />
                ) : (
                  <WhatsappIcon width={24} height={24} color="var(--color-neutral-light)" background="#020202" />
                )
              }
            />
          </FormGroup>
          <FormGroup>
            <Input
              id="floatingWhatsappMessage"
              type="text"
              value={section.message || ""}
              onChange={e =>
                setSection({
                  ...section,
                  message: e.target.value,
                })
              }
              maxLength={140}
              label={t("pages.editor.floatingWhatsapp.form.message")}
            />
          </FormGroup>
        </Box>
        <SaveBar onSave={saveHandler} disabled={!hasValidWhatsapp} hasUnsavedChanges={hasUnsavedChanges} />
      </Form>
    </Container>
  );
};

export default FloatingWhatsappPage;
